// mantine
import { Card, UnstyledButton } from '@mantine/core';
import { modals } from '@mantine/modals';
// utils
import { IWorkflowStep } from '@/pages/Workflow/Workflow.types.ts';
// components
import ContextMenu from '@/pages/Workflow/components/ContextMenu';
import StepForm from '@/pages/Workflow/components/StepForm/StepForm.tsx';
// assets
import styles from '@/pages/Workflow/components/WorkflowStep/WorkflowStep.module.css';

interface WorkflowStepProps {
    data: IWorkflowStep;
}

const WorkflowStep = ({ data }: WorkflowStepProps) => {
    const handleAdd = (type: 'format' | 'instruction' | 'context') => {
        const labels: string[] = [...data.industries, ...data.workflows];
        if (type === 'format') {
            labels.push('task_object_format');
        }

        if (type === 'instruction') {
            labels.push('task_instruction');
        }

        if (type === 'context') {
            labels.push('task_context');
        }

        modals.open({
            title: `Add ${type}`,
            size: '70%',
            children: (
                <StepForm
                    labels={labels}
                    name={data.name}
                    personaId={data.persona_id}
                    onClose={() => {
                        modals.closeAll();
                    }}
                />
            )
        });
    };
    return (
        <Card className={styles.step}>
            <div className="mb-2 font-semibold">{data.name}</div>
            <Card className={styles.format}>
                <div className="flex justify-between">
                    <div className="font-semibold">task_object_format</div>
                    {data.format ? (
                        <ContextMenu topic={data.format} />
                    ) : undefined}
                </div>

                <div className={styles.grid}>
                    <div className="italic text-gray-6">receiver_task_idn</div>
                    <div>{data.schema.receiver_task_idn}</div>
                    <div className="italic text-gray-6">
                        receiver_worker_idn
                    </div>
                    <div>{data.schema.receiver_worker_idn}</div>
                    <div className="italic text-gray-6">
                        second_receiver_task_idn
                    </div>
                    <div>{data.schema.second_receiver_task_idn}</div>
                    <div className="italic text-gray-6">
                        second_receiver_worker_idn
                    </div>
                    <div>{data.schema.second_receiver_worker_idn}</div>
                </div>
            </Card>
            <Card className={styles.instruction}>
                <div className="mb-2 flex justify-between">
                    <div className="font-semibold">task_instruction</div>
                    {data.instruction ? (
                        <ContextMenu topic={data.instruction} />
                    ) : undefined}
                </div>
                {data.instruction ? (
                    data.instruction.topic_summary
                ) : (
                    <UnstyledButton
                        className={styles.empty}
                        onClick={() => {
                            handleAdd('instruction');
                        }}
                    >
                        + Add instruction
                    </UnstyledButton>
                )}
            </Card>
            <Card className={styles.context}>
                <div className="flex justify-between">
                    <div className="font-semibold">task_context</div>
                    {data.context.length > 0 && (
                        <ContextMenu topic={data.context[0]} />
                    )}
                </div>
                {data.context.length > 0 ? (
                    data.context.map((topic) => (
                        <div key={topic.topic_id}>{topic.topic_summary}</div>
                    ))
                ) : (
                    <UnstyledButton
                        className={styles.empty}
                        onClick={() => {
                            handleAdd('context');
                        }}
                    >
                        + Add context
                    </UnstyledButton>
                )}
            </Card>
        </Card>
    );
};

export default WorkflowStep;
